import React from 'react';

import styled from 'styled-components';

import BoraPage from '../components/BoraPage';

const StyledPara = styled.p`
    color: ${props => props.theme.fgColor};
    max-width: 40em;
    text-align: left;
    margin: auto auto;
    margin-top: 0.5em;
`;

const Para = () => (<React.Fragment>
  <StyledPara>Oorstrelend spektakel, fluisterzacht en intiem, of dwars door alle muren heen. Bach en de blues,
    tango’s met een twist, jazz in een nieuw jasje. Oorstrelend spektakel, fluisterzacht en intiem, of dwars door alle
    tango’s met een twist, jazz in een nieuw jasje. fluisterzacht en intiem, of dwars door alle
    tango’s met een twist. Oorstrelend spektakel, fluisterzacht en intiem, of dwars door alle
    tango’s met een twist. Het gebeurt elk jaar wel een keer dat bij groothandelaren een truck of vrachtlading nootjes
    wordt gestolen. "Dat hou je altijd bij een product dat vrij kostbaar is", zegt Barbara Niemans van
    brancheorganisatie de Nederlandse Zuidvruchten Vereniging (NZV).
  </StyledPara>
  <StyledPara>Er is geen sprake van een stijgende trend, concludeert Niemans na een interne rondgang. De NZV waarschuwt
    leden als er verdachte partijen rondgaan of wanneer er verdachte verkopers actief zijn op de Nederlandse markt. Hoe
    vaak dit gebeurt, daar zijn geen cijfers van.
  </StyledPara>
  <pre>
    npm install -g svgo
  </pre>
  <StyledPara>
    Een eigenaar van een groothandel in Moerdijk, die liever anoniem wil blijven, maakte vorig jaar nog een diefstal
    mee. Een aangeleverde container zat maar halfvol met amandelen. "Die was gewoon leeggehaald in de haven", zegt hij
    aan de telefoon. Een strop van vele tienduizenden euro's. Want een volle container amandelen, zo'n twintig ton, kost
    hem 136.000 euro.</StyledPara>
</React.Fragment>);


export default () => (
  <BoraPage pageName="Nieuws" pageTitle="Welkom in de borrelbar" slug="nieuws">
    <h3>Head 3</h3>
    <Para/>
    <h4>Head 4</h4>
  </BoraPage>
);
